/**
 * Supported domain names include:
 * External PROD:
 * - stubhub.<TLD>
 *
 * LEGACY Internal PROD:
 * - stubprod.com
 *
 * LEGACY External NON-PROD:
 * - stubhubdev.<TLD>
 * - stubhubstage.<TLD>
 *
 * LEGACY Internal NON-PROD:
 * - slcqXXX.<TLD>
 * - slceXXX.<TLD>
 * - slcdXXX.<TLD>
 * - slcsXXX.<TLD>
 *
 * PaaS/PCF https://wiki.stubcorp.com/display/PCF/PaaS+Host+Naming+Standards
 * PCF Internal PROD:
 * - stubsys.io
 * - stubsys.cloud
 * - stubapp.io
 * - stubapp.cloud
 *
 * PCF Internal NON-PROD:
 * - npstubsys.io
 * - npstubsys.cloud
 * - npstubapp.io
 * - npstubapp.cloud
 *
 * GCP Native:
 * https://PROJECT_ID.REGION_ID.r.appspot.com
 *
 * Others
 * - stubhublabs.com
 * - localhost
 */

const SUPPORTED_DOMAIN_NAMES_REX =
  /stubhub\.|stubprod.com|stubhubdev\.|stubhubstage\.|slc(e|d|q|s)[0-9]{3}\.|(np)?stub(sys|app)\.(io|cloud)|stubhublabs\.com|localhost|appspot\.com|shprodcloud.com|stubcloud(prod|dev|stage)\./i;

/**
 * Integration domains are those supporting E2E flows
 * - stubhub.<TLD>
 * - stubhubdev.<TLD>
 * - www.slcqXXX.<TLD>
 * - www.slceXXX.<TLD>
 * - www.slcdXXX.<TLD>
 * - www.slcsXXX.<TLD>
 */
const INTEGRATION_DOMAIN_NAMES_REX =
  /stubhub\.|stubhubdev\.|stubhubstage\.|www\.slc(e|d|q|s)[0-9]{3}\.|stubcloud(prod|dev|stage)\./i;

function isSupportedDomain(domainName) {
  return SUPPORTED_DOMAIN_NAMES_REX.test(domainName);
}

function isIntegrationDomain(domainName) {
  return INTEGRATION_DOMAIN_NAMES_REX.test(domainName);
}

exports.isSupportedDomain = isSupportedDomain;
exports.isIntegrationDomain = isIntegrationDomain;
